module.exports = __webpack_public_path__ + "img/imagen1.11aa7447.png";